export const NOOP = () => {
};   // 无操作，常用于props缺省值
export const JUST_RETURN = _ => _;    // 直接返回
export const RETURN_NULL = () => null; // 返回 null
export const RETURN_EMPTY_OBJECT = () => ({});    // 返回空对象，常用于connect传递空的mapStateToProps
export const EMPTY_PAGE_BEAN = {
  recordList: []
};

export const USER_LEVER = ['LV1伴读书童', 'LV2快乐秀才', 'LV3进击举人', 'LV4进士及第', 'LV5状元郎', 'LV6翰林大学士', 'LV7文圣'];

export const SERIES_MAGE = 'https://file.5rs.me/oss/uploadfe/png/2c9c9d0156af527cf2ad80ca1578331d.png';

// 缺省图
// 无历史记录
export const NO_RECORD_DEFAULT_IMG = 'https://file.5rs.me/oss/uploadfe/png/f93b471cdc4e3602eea114d992743ab3.png';
// 无网络
export const NO_NETWORD_DEFAULT_IMG = 'https://file.5rs.me/oss/uploadfe/png/3e92a40a9349817c3d2ae2a1e7831cf7.png';
// 无券
export const NO_CUPONS_DEFAULT_IMG = 'https://file.5rs.me/oss/uploadfe/png/d51b70c6190639c706a3a29851d5a761.png';
// 无社群
export const NO_GROUP_DEFAULT_IMG = 'https://file.5rs.me/oss/uploadfe/png/5d3129b5e7ff87c3d544490c204a8660.png';
// 无资源
export const NO_RESOURCE_DEFAULT_IMG = 'https://file.5rs.me/oss/uploadfe/png/e7649da704c94ed7f7e1a6ff85258ccb.png';
// 通用
export const NO_EVERYTHING_DEFAULT_IMG = 'https://oss.5rs.me/oss/uploadfe/png/a3dd7e2611b33b9c8bc34c1e28ae9d04.png';

/** 资源类型值 与后端统一 */
export const SERVE_TYPES = {
  NEWS: 1,
  ADVISER_GROUP: 2,
  MODEL_GROUP: 3,
  THIRD_GROUP: 4,
  PRODUCT: 5,
  APP: 6,
  BOOK: 7,
  BOOK_RECOMMEND: 8,
  BOOK_LIST: 9,
  SCM_PRODUCT: 26
};

/** 本书服务页栏目 serveType  */
export const COLUMN_SERVE_TYPES = {
  /** 应用作品 */
  APP_PRODUCT: 'APP/PRODUCT', // 应用作品
  KNOWLEDGE_APP: 'KNOWLEDGE_APP', // AI应用
  /** 公众号 */
  OFFICIAL_ACCOUNT: 'OFFICIAL_ACCOUNT', // 公众号
  /** 平台书单 */
  BOOKLIST: 'BOOKLIST', // 平台书单
  /** 编辑书刊 */
  ADVISER_BOOK: 'ADVISER_BOOK', // 编辑书刊
  /** 群 */
  GROUP_ACTIVITY: 'GROUP_ACTIVITY', // 群

  /**企业微信群 */
  WXWORK_GROUP: 'WXWORK_GROUP', //企业微信群
  /** 第三方资源 */
  THIRD_RESOURCE: 'THIRD_RESOURCE', // 第三方资源
  /** 本书评价 */
  BOOK_ASSESS: 'BOOK_ASSESS', // 本书评价
  /** 平台会员活动 */
  MEMBER_ACTIVITY: 'MEMBER_ACTIVITY', // 平台会员活动
  /** 运营商城 */
  SHOP: 'SHOP', // 跳转商城
  OUTER_LINK: 'OUTER_LINK', //渠道链接
  MULTI_CHANNEL: 'MULTI_CHANNEL', //多渠道内容
  FOLDER: 'FOLDER',  //通用组件
  LINK: 'LINK', //外链
  CUSTOMER_QA: 'CUSTOMER_QA', // 智能客服
  HOTRECOMMEND: 'HOTRECOMMEND' // 拓展服务
};

export const EMPTY_IMG = 'https://file.5rs.me/oss/uploadfe/gif/b77d8e479348da362f0a8a2be1405837.gif';

/** 公众号页面分享时的默认图 */
export const RAY_AVATAR = 'https://file.5rs.me/oss/uploadfe/png/782544053039e776b5379878a18de70e.png';

// 足迹页大图
export const FOOTPRINT_HEADER_IMG = 'https://file.5rs.me/oss/uploadfe/png/c85a498d9895690ac2dbfcf187fbf875.png';
export const FOOTPRINT_HEADER_SM = 'https://file.5rs.me/oss/uploadfe/png/23b4c9e3be7a9fe1f089a61debcc6f6f.png';

/** 分享时给的固定图 */
export const IMAGES_FOR_SHARE = {
  TO_HOME: 'https://file.5rs.me/oss/uploadfe/png/d8b71a89315b9795ea5562a865dba5e4.png', // 默认图
  TO_CUSTOMIZE: 'https://file.5rs.me/oss/uploadfe/png/a555b38bc23b391d7abeef1aa6da344d.png' // 直接到 本书服务页
};

// 小睿模版
export const STYLE_LIST = [
  {
    templateCode: 'DEFAULT',
    templateName: '默认风格',
    templateId: 1
  },
  {
    templateCode: 'BLUE',
    templateName: '典雅蓝',
    templateId: 2,
    templateImg: 'https://r.5rs.me/image/5e3d323d-55d1-4141-889a-c8e7a23aef07/67a8b54e3b93f6515f4bb4d056d9b896.png'
  },
  {
    templateCode: 'GREEN',
    templateName: '清新绿',
    templateId: 3
  },
  {
    templateCode: 'WHITE',
    templateName: '清爽白',
    templateId: 4
  },
  {
    templateCode: 'PURPLE',
    templateName: '水晶紫',
    templateId: 5
  }
];

/** 字母表 */
export const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

/* NFT_KXD */
export const NFT_KXD = 'NFT_KXD';

/** 公众号页面斗罗分享时的默认图 */
export const DOULUO_AVATAR = 'https://file.5rs.me/oss/uploadfe/png/06fea6dbdb47478211eb11e2e761eb01.png';

export const DOULUO_AVATAR_TWO = 'https://file.5rs.me/oss/uploadfe/jpg/d6b0e2885f997a00019c47edb10bc4c6.jpg';

export const DOULUO_AVATAR_THREE = 'https://oss.5rs.me/oss/uploadfe/jpg/0cee760dfe886f10d3c67b64e98c62fb.jpg';

export const DOULUO_AVATAR_FOUR = 'https://oss.5rs.me/oss/uploadfe/jpg/f7966e3f8585fbe211f9427f058bcd2d.jpg';

export const TOAST_SUCCESS_IMG = 'https://oss.5rs.me/oss/uploadfe/png/8628e303e59110f5359b9a43a030fc89.png';
export const TOAST_CANLE_IMG = 'https://oss.5rs.me/oss/uploadfe/png/9f507170db317cabd175798926c86aa4.png';

export const WHUT_LOGO = 'https://oss.5rs.me/oss/uploadfe/png/70542460578e0202daa0ee3da58f967b.png';
